// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_j9-0";
export var fileCarousel = "_j9-2";
export var removeFileButton = "_j9-1";